import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/shared/ui/button';
import { Logo } from './logo';

export function NotFound() {
  return (
    <div className="grid min-h-screen place-items-center p-6">
      <div className="glass glass-sheen flex max-w-md flex-col items-center gap-5 rounded-2xl p-10 text-center">
        <Logo size={44} showWordmark={false} />
        <Compass className="size-10 text-muted-foreground" />
        <div>
          <h1 className="text-xl font-semibold">Página não encontrada</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            O endereço que você tentou acessar não existe ou foi movido.
          </p>
        </div>
        <Button asChild>
          <Link to="/">Voltar ao início</Link>
        </Button>
      </div>
    </div>
  );
}
